import { css } from "lit";


export const selectOptionStyles = css`
  :host {
    --select-option__color: var(--_select-option__color, var(--sbkSelectColorFgColorOnLightDefault));
    --select-option__color--active: var(--_select-option__color--active, var(--sbkSelectColorFgColorOnDarkEnabled));
    --select-option__color--disabled: var(--_select-option__color--disabled, var(--sbkSelectColorFgColorOnLightDisabled));

    --select-option__bg: var(--_select-option__bg, var(--sbkSelectColorBgColorOnLightFlyoutEnabled));
    --select-option__bg--active: var(--_select-option__bg--active, var(--sbkSelectColorBgColorOnLightFlyoutActive));
      display: block;
  }
  
  * {
    box-sizing: border-box;
  }
    
  :host(:first-of-type:hover), :host(:first-of-type.select-option--current) {
    border-radius: var(--sbkSelectBorderRadiusDefault) var(--sbkSelectBorderRadiusDefault) 0 0;
  }

  :host(:last-of-type:hover), :host(:last-of-type.select-option--current) {
    border-radius: 0 0 var(--sbkSelectBorderRadiusDefault) var(--sbkSelectBorderRadiusDefault);
  }

  .select-option {
    cursor: pointer;
    padding: var(--sbkSelectSpacingXs);
    color: var(--select-option__color);
    border-radius: inherit;
  }

  .select-option--single-select {
    font: var(--sbkSelectTypographyFlyoutSm);

    .select-option__description {
      margin-top: var(--sbkSelectSpacing2xs);
      font: var(--sbkSelectTypographyFlyoutXs);
    }
  }

  .select-option--empty-option {
    color: var(--select-option__color--disabled)
  }

  @media (hover: hover) and (pointer: fine) {
      .select-option:hover {
          background-color: var(--select-option__bg--active);
          color: var(--select-option__color--active);
      }
  }

  :host(.select-option--current) .select-option {
    background-color: var(--select-option__bg--active);
    color: var(--select-option__color--active);
  }

  ::part(checkbox-wrapper) {
      margin-bottom: 0;
  }
`;